/* Direction-aware header; isolated from cart, checkout and theme authorization. */
(()=>{
 const init=()=>{
  document.querySelectorAll('.ch-header-section').forEach(header=>{
   if(header.dataset.scrollReady)return;
   header.dataset.scrollReady='true';
   let last=Math.max(0,window.scrollY),distance=0,direction=0,queued=false;
   const show=()=>header.classList.remove('ch-header--concealed');
   const locked=()=>Boolean(header.querySelector('details[open],dialog[open]'))||Boolean(header.querySelector(':focus-visible'));
   const measure=()=>header.style.setProperty('--ch-collapse-height',`${Math.ceil(header.getBoundingClientRect().height)+2}px`);
   const observer=new ResizeObserver(measure);observer.observe(header);measure();
   const update=()=>{
    queued=false;
    const y=Math.max(0,Math.min(window.scrollY,document.documentElement.scrollHeight-window.innerHeight));
    const delta=y-last;last=y;
    if(y<80||locked()){show();distance=0;return;}
    if(Math.abs(delta)<1)return;
    const next=delta>0?1:-1;
    distance=next===direction?distance+Math.abs(delta):Math.abs(delta);direction=next;
    if(next<0&&distance>=8)show();
    if(next>0&&distance>=18&&y>header.offsetHeight+40)header.classList.add('ch-header--concealed');
   };
   const scroll=()=>{if(!queued){queued=true;requestAnimationFrame(update);}};
   const toggle=()=>{if(locked())show();};
   window.addEventListener('scroll',scroll,{passive:true});
   header.addEventListener('focusin',show);header.addEventListener('toggle',toggle,true);
   const editor=()=>show();document.addEventListener('shopify:section:select',editor);
   const unload=e=>{if(e.target===header||e.target.contains(header)){window.removeEventListener('scroll',scroll);observer.disconnect();header.removeEventListener('focusin',show);header.removeEventListener('toggle',toggle,true);document.removeEventListener('shopify:section:select',editor);document.removeEventListener('shopify:section:unload',unload);}};
   document.addEventListener('shopify:section:unload',unload);
  });
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
 document.addEventListener('shopify:section:load',init);
})();
